import React, { useContext, useEffect, useState, useTransition } from "react";
import "./RPAs.scss";
import "./RPAsMobile.scss";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import CaixaLista from "@components/caixalista/CaixaLista";
import IconPVA from "@icons/IconPVA";
import EndPointServices from "@services/ApiServices";
import UtilServices from "@services/UtilServices";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import MessageServices from "@services/MessageServices";
import Modal from "@components/modal/Modal";
import InputPesquisa from "@components/inputPesquisa/InputPesquisa";
import useLoading from "@hooks/useLoading";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import Button from "@components/button/Button";
import { set } from "react-hook-form";

const RPAs = () => {
  const [isPending, startTransition] = useTransition();
  const [isPendingA, startTransitionA] = useTransition();
  const [isPendingB, startTransitionB] = useTransition();

  useLoading(isPending);

  //Variaveis Padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //Caixa Lista
  const [dadoscaixa, setDadosCaixa] = useState([]);

  //GridRegras
  const [dadosGridRegra, setDadosGridRegra] = useState([]);
  const [showGridRegra, setShowGridRegra] = useState(false);
  //GridAnalítico
  const [dadosAnalitico, setDadosAnalitico] = useState([]);
  const [dadosAnaliticoFilter, setDadosAnaliticoFilter] = useState([]);
  //Modal
  const [showModal, setShowModal] = useState(false);
  const [showModalB, setShowModalB] = useState(false);
  const [del, setDel] = useState([]);
  const [base64, setBase64] = useState("");
  const [tipoarquivo, setTipoarquivo] = useState("");
  const [critica, setCritica] = useState("");

  //inputpesquisa
  const [lstkey] = useState([
    {
      id: 1,
      valor: "Razão Social",
      type: "text",
      mask: "",
      placeholder: "",
    },
    {
      id: 2,
      valor: "CNPJ",
      type: "text",
      mask: "CNPJ",
      placeholder: "00.000.000/0000-00",
    },
    {
      id: 3,
      valor: "Status",
      type: "text",
      mask: "",
      placeholder: "",
    },
    {
      id: 4,
      valor: "Competência",
      type: "text",
      mask: "mesAno",
      placeholder: "MM/AAAA",
    },
  ]);
  const [listValue, setListValue] = useState([]);
  const [retornoPesquisa, setRetornoPesquisa] = useState([]);
  const [clear, setClear] = useState(false);

  //Second
  const [showSecond, setShowSecond] = useState(false);
  const [second, setSecond] = useState(0);

  //Ids Empresa
  const [ids_automacao, setIds_automacao] = useState([]);

  useEffect(() => {
    handleStart();
  }, []);

  useEffect(() => {
    if (showSecond) {
      const intervalo = setInterval(() => {
        handleConsultaEmpresa_Second();
        setSecond(0);
      }, 10000); // 10000 ms = 10 segundos
      return () => clearInterval(intervalo);
    }
  }, [showSecond]);

  useEffect(() => {
    if (showSecond) {
      const contador = setInterval(() => {
        setSecond((prev) => prev + 1);
      }, 1000);

      return () => clearInterval(contador);
    }
  }, [showSecond]);

  //Esc
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape" && showModal) {
        setShowModal(false);
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModal]);

  //Incialização
  function handleStart() {
    let pesquisastorage = [];
    // pega a pesquisa do storage ou context
    if (state.pesquisa.length > 0) {
      pesquisastorage = state?.pesquisa;
    } else {
      let e = UtilServices.getStorage("pesquisa");
      if (e.length > 0) {
        pesquisastorage = e;
      }
    }
    setRetornoPesquisa(pesquisastorage);
    handleConsultaEmpresa(pesquisastorage);
  }
  async function handleConsultaEmpresa_Second() {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
      id_compartilhado: 1,
    };

    const itemStorage = UtilServices.getStorage("clickcaixaactive");
    var retornoapi = await EndPointServices.Rpa_ConsultaEmpresa(data);

    if (retornoapi?.Success) {
      let dadosca = [];
      //dados caixa lista
      dadosca = retornoapi.BaseReturn?.LstClasse?.map((item, index) => ({
        id: index + 1,
        id_empresa: item["id_empresa"],
        ativo: itemStorage?.id_empresa === item["id_empresa"] ?? false,
        mes: {
          desc: item["Competência"],
          style: { fontSize: "10px", width: "auto" },
        },
        nome: {
          desc: item["Razão Social"],
          style: { fontSize: "10px", width: "200px" },
        },
        cnpj: {
          desc: UtilServices.maskCNPJ(item["cnpj"]),
          style: { fontSize: "12px", width: "auto", marginRight: "10px" },
        },
        ...(item["exibirpdf"]
          ? {
              icon2: {
                desc: "<i class='fa-solid fa-eye'></i>",
                title: "Vizualizar PDF ou PNG",
                color: "#fff",
                onClick: () => {
                  handleConsultaArquivoEFD({
                    base64: item["base64"],
                    tipoarquivo: item["tipoarquivo"],
                    obs: item["Observações"],
                  });
                  setShowModal(true);
                },
              },
            }
          : {}),
        icon: {
          desc: item["icon"],
          title: item["statuscaixa"],
          color: item["color"],
        },
      }));
      setDadosCaixa(dadosca);
      //dados analitico
      setDadosAnalitico(retornoapi.BaseReturn.LstClasse);
      setDadosAnaliticoFilter(retornoapi.BaseReturn.LstClasse);
      handleFiltroConsulta(
        retornoapi.BaseReturn.LstClasse,
        UtilServices.getStorage("pesquisa"),
      );

      let e = UtilServices.getStorage("clickcaixa");
      if (e.length === 0) return;
      let filterlista = dadosAnalitico?.filter(
        (item) => item.id_empresa === e.id_empresa,
      );
      setDadosAnaliticoFilter(filterlista);
    }
  }
  function handleConsultaEmpresa(pesquisa = []) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_compartilhado: 1,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaEmpresa(data);

      if (retornoapi?.Success) {
        let dadosca = [];
        //dados caixa lista
        dadosca = retornoapi.BaseReturn?.LstClasse?.map((item, index) => ({
          id: index + 1,
          id_empresa: item["id_empresa"],
          mes: {
            desc: item["Competência"],
            style: { fontSize: "10px", width: "auto" },
          },
          nome: {
            desc: item["Razão Social"],
            style: { fontSize: "10px", width: "200px" },
          },
          cnpj: {
            desc: UtilServices.maskCNPJ(item["cnpj"]),
            style: { fontSize: "12px", width: "auto", marginRight: "10px" },
          },
          ...(item["exibirpdf"]
            ? {
                icon2: {
                  desc: "<i class='fa-solid fa-eye'></i>",
                  title: "Vizualizar PDF ou PNG",
                  color: "#fff",
                  onClick: () => {
                    handleConsultaArquivoEFD({
                      base64: item["base64"],
                      tipoarquivo: item["tipoarquivo"],
                      obs: item["Observações"],
                    });
                    setShowModal(true);
                  },
                },
              }
            : {}),
          icon: {
            desc: item["icon"],
            title: item["statuscaixa"],
            color: item["color"],
          },
        }));
        setDadosCaixa(dadosca);
        //dados analitico
        setDadosAnalitico(retornoapi.BaseReturn.LstClasse);
        setDadosAnaliticoFilter(retornoapi.BaseReturn.LstClasse);
        handleFiltroConsulta(retornoapi.BaseReturn.LstClasse, pesquisa);
      }
    });
  }
  function handleConsultaEmpresaRegra(e) {
    let analitico = handleFiltroConsulta(
      dadosAnalitico,
      UtilServices.getStorage("pesquisa"),
      e?.id,
    );

    if (!e?.ativo) {
      setShowGridRegra(false);
      setDadosAnaliticoFilter(analitico);
      UtilServices.setStorage("clickcaixa", []);
      return;
    }
    UtilServices.setStorage("clickcaixa", e);
    let filterlista = dadosAnalitico?.filter(
      (item) => item.id_empresa === e.id_empresa,
    );
    setDadosAnaliticoFilter(filterlista);
    setShowGridRegra(true);

    startTransitionA(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_empresa: e?.id_empresa,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegra(data);
      if (retornoapi?.Success) {
        setDadosGridRegra(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  async function handleConsultaArquivoEFD(e) {
    let base64 = await handleConsultaBase64(e);

    setTipoarquivo(e.tipoarquivo);
    setBase64(base64);
    setCritica(e.obs);
  }
  async function handleDownloadArquivoEFD(e) {
    let base64 = await handleConsultaBase64(e);

    if (e.tipoarquivo === "png") {
      UtilServices.base64inPNG(base64);
    } else if (e.tipoarquivo === "txt") {
      UtilServices.base64inTXT(base64);
    } else {
      UtilServices.base64inPDF(base64);
    }
  }
  async function handleConsultaBase64(e) {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
      id_automacao: e?.id_automacao,
      id_compartilhado: e?.id_compartilhado,
      tipoarquivo: e?.tipoarquivo,
    };
    var retornoapi = await EndPointServices.Rpa_ConsultaBase64(data);
    if (retornoapi?.Success) {
      return retornoapi?.BaseReturn?.LstClasse[0].base64;
    }
    return null;
  }

  //input pesquisa
  function handleFunctionKey(tp) {
    let lstvalue = [];

    //Razão Social
    if (tp.id === 1) {
      lstvalue = dadosAnalitico
        ?.map((e) => ({
          ID: e["id_empresa"],
          valor: e["Razão Social"],
        }))
        ?.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.valor === item.valor),
        );
      //CNPJ
    } else if (tp.id === 2) {
      lstvalue = dadosAnalitico
        ?.map((e, index) => ({
          ID: e["id_empresa"],
          valor: UtilServices.maskCNPJ(e.cnpj),
        }))
        ?.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.valor === item.valor),
        );
    } else if (tp.id === 3) {
      lstvalue = dadosAnalitico
        ?.map((e, index) => ({
          ID: e["id_status"],
          valor: e.Status,
        }))
        ?.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.valor === item.valor),
        );
    } else if (tp.id === 4) {
      lstvalue = dadosAnalitico
        ?.map((e, index) => ({
          ID: index + 1,
          valor: e["Competência"],
        }))
        ?.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.valor === item.valor),
        );
    }
    setListValue(lstvalue);
  }
  function handleFiltroConsulta(dados, pesquisa = [], idAtivo) {
    let dadosFilter = [];

    if (pesquisa.length > 0) {
      let idfiltro1 = pesquisa
        .filter((f) => [1, 2].includes(f.key?.id))
        .map((f) => f.valor.ID);

      let idfiltro2 = pesquisa
        .filter((f) => f.key?.id === 3)
        .map((f) => f.valor.ID);

      let idfiltro3 = pesquisa
        .filter((f) => f.key?.id === 4)
        .map((f) => f.valor?.valor);

      dadosFilter = dados?.filter((e) => {
        const filtroEmpresa = idfiltro1?.length
          ? idfiltro1.includes(e.id_empresa)
          : true;
        const filtroStatus = idfiltro2?.length
          ? idfiltro2.includes(e.id_status)
          : true;
        const filtroCompetencia = idfiltro3?.length
          ? idfiltro3.includes(e["Competência"])
          : true;

        return filtroEmpresa && filtroStatus && filtroCompetencia;
      });
    } else {
      dadosFilter = dados;
    }
    //dados caixa de lista.
    let dadosca = dadosFilter?.map((item, index) => ({
      id: index + 1,
      id_empresa: item["id_empresa"],
      ativo: index + 1 === idAtivo,
      mes: {
        desc: item["Competência"],
        style: { fontSize: "10px", width: "auto" },
      },
      nome: {
        desc: item["Razão Social"],
        style: { fontSize: "10px", width: "200px" },
      },
      cnpj: {
        desc: UtilServices.maskCNPJ(item["cnpj"]),
        style: { fontSize: "12px", width: "auto", marginRight: "10px" },
      },
      ...(item["exibirpdf"]
        ? {
            icon2: {
              desc: "<i class='fa-solid fa-eye'></i>",
              title: "Vizualizar PDF ou PNG",
              color: "#fff",
              onClick: () => {
                handleConsultaArquivoEFD({
                  base64: item["base64"],
                  tipoarquivo: item["tipoarquivo"],
                  obs: item["Observações"],
                  id_automacao: item.id_automacao,
                  id_compartilhado: item.id_compartilhado,
                });
                setShowModal(true);
              },
            },
          }
        : {}),
      icon: {
        desc: item["icon"],
        title: item["statuscaixa"],
        color: item["color"],
      },
    }));
    setDadosAnaliticoFilter(dadosFilter);
    setDadosCaixa(dadosca);

    return dadosFilter;
  }
  function handleDeletaRegra(idRegra) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_regra: idRegra,
      };

      var retornoapi = await EndPointServices.Rpa_DeletaRegra(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Regra deletada com sucesso.");
        handleConsultaEmpresa();
        setShowGridRegra(false);
      }
    });
  }
  //Deleta
  function handleDeletaEmpresa() {
    startTransitionB(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_automacao: del?.id_automacao,
        flg_excluir: del?.excluir,
      };
      var retornoapi = await EndPointServices.Rpa_DeletaEmpresa(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess(
          `Empresa ${del?.excluir ? "excluida " : "cancelada"} com sucesso !`,
        );
        handleConsultaEmpresa();
      }
    });
    setShowModalB(false);
  }
  //Consulta Regra
  function handleConsultaRegraDetalhada(id_regra) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_regra: id_regra,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegraDetalhada(data);
      if (retornoapi?.Success) {
        dispatch({
          type: "SET_REGRASELECIONADA",
          payload: retornoapi?.BaseReturn?.LstClasse,
        });
        navigate("/RPA/Cadastro/Regras");
      }
    });
  }
  //set retorno pesquisa
  function handlePesquisa(e) {
    setRetornoPesquisa(e);
    dispatch({
      type: "SET_PESQUISA",
      payload: e,
    });

    handleFiltroConsulta(dadosAnalitico, e);

    if (e.length > 0) {
      UtilServices.setStorage("pesquisa", e);
    }
  }
  //Reprocessar
  function handleReprocessar(e) {
    if (ids_automacao.length === 0) {
      MessageServices.ShowWarning(
        "É obrigatório selecionar ao menos uma empresa no grid.",
      );
      return;
    }

    startTransition(async () => {
      let dados = {
        ids_automacao: ids_automacao.map((item) => ({
          id_automacao: item.id_automacao,
        })),
      };

      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_compartilhado: 1,
        json: dados,
      };

      var retornoapi =
        await EndPointServices.Rpa_CreateEmpresaReprocessar(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Reprocessamento iniciado com sucesso!");
        handleStart();
      }
    });
  }

  return (
    <div className="rpas row">
      <div className="col-12 mb-4 passo-1" style={{ position: "relative" }}>
        <InputPesquisa
          title="Pesquisar"
          // loading1={true}
          // loading2={true}
          listKey={lstkey}
          listValue={listValue}
          handleFunctionKey={handleFunctionKey}
          setRetorno={(e) => {
            handlePesquisa(e);
          }}
          clear={clear}
          setClear={setClear}
          addLstStorage={UtilServices.getStorage("pesquisa")}
          namestorage="pesquisa"
        />
        <div
          className="icons-input-pesquisa"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            position: "absolute",
            left: "430px",
            top: "25px",
          }}
        >
          <ButtonIcon
            Clear
            className="clear-icon"
            titleClear="Limpar os filtros"
            onClear={() => {
              startTransition(() => {
                setRetornoPesquisa([]);
                dispatch({
                  type: "SET_PESQUISA",
                  payload: [],
                });
                UtilServices.setStorage("pesquisa", []);
                setClear(true);
              });
            }}
          />
          <ButtonIcon
            Refresh
            className="clear-icon"
            titleRefresh="Refresh na tela"
            onRefresh={async () => {
              handleConsultaEmpresa(retornoPesquisa);
            }}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 passo-2">
        <div
          className="restart col-md-6 col-5"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "5px",
            padding: "0px 20px",
            width: "100%",
            justifyContent: "start",
          }}
        >
          <p>{UtilServices.maskFormatTime(second)}</p>
          <ButtonIcon
            Playpause
            PlaypauseClassName="passo-5"
            onPlaypause={() => {
              setShowSecond(!showSecond);
              setSecond(0);
            }}
            titlePlaypause="Atualizar a cada 5 segundos a pagina."
            typePlaypause="submit"
          />
        </div>
        <CaixaLista
          icon={<IconPVA />}
          title="EFD Contribuições"
          iconMais={{
            icon: '<i class="fa-solid fa-plus"></i>',
            onClick: () => {
              navigate("/RPA/Cadastro/Empresa");
            },
            title: "Cadastrar nova empresa",
          }}
          onClick={(e) => {
            handleConsultaEmpresaRegra(e);
          }}
          lista={dadoscaixa}
          setLista={setDadosCaixa}
        />
      </div>
      <div
        className="col-12 mt-5 mt-md-0 col-md-6"
        style={{ position: "relative" }}
      >
        {showGridRegra && (
          <>
            <Button
              nome="Nova Regra"
              className="novaregra"
              icon="<i class='fa-solid fa-plus'></i>"
              theme="2"
              onClick={() => {
                navigate("/RPA/Cadastro/Regras");
              }}
            />
            <Grid
              dadosGrid={dadosGridRegra}
              columns={mappingColumn.getRPA_Regras(
                dadosGridRegra,
                handleDeletaRegra,
                handleConsultaRegraDetalhada,
              )}
              {...(dadosGridRegra?.length > 0 && {
                pageVisible: true,
              })}
              noDataText="Sem dados, Clique em Nova Regra"
              iconTitle="<i class='fa-solid fa-scale-balanced'></i>"
              title="Regras"
              Memo={false}
              useLoading={isPendingA}
              pagingStaticSize="5"
            />
          </>
        )}
      </div>
      <div className="col-12 mt-5 mb-5 passo-3">
        <Button
          nome="Reprocessar"
          icon="<i class='fa-solid fa-arrows-rotate'></i>"
          theme="2"
          className="button-reprocessar"
          onClick={() => {
            handleReprocessar();
          }}
          disabled={ids_automacao.length === 0}
        />
        <Grid
          dadosGrid={dadosAnaliticoFilter}
          columns={mappingColumn.getRPA_Analitico(
            dadosAnaliticoFilter,
            setShowModal,
            handleConsultaArquivoEFD,
            handleDownloadArquivoEFD,
            setShowModalB,
            setDel,
          )}
          {...(dadosAnaliticoFilter?.length > 0 && {
            pageVisible: true,
          })}
          selection={{
            allowSelectAll: true,
            mode: "multiple",
            showCheckBoxesMode: "always",
          }}
          iconTitle="<i class='fa-solid fa-file-chart-column'></i>"
          title="Analítico das empresas"
          noDataText="Nenhuma empresa na fila do robô"
          useLoading={isPendingB}
          Memo={showSecond}
          pagingStaticSize="5"
          onSelectionChanged={(e) => {
            setIds_automacao(e.selectedRowKeys);
          }}
        />
      </div>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Visualizador"
        width="90vw"
        height="90vh"
      >
        <div style={{ height: "80vh", width: "100%", overflow: "auto" }}>
          <div className="criticas">
            <p className="title">Críticas:</p>
            <p>{critica}</p>
          </div>
          {tipoarquivo === "png" ? (
            <img
              src={`data:image/png;base64,${base64}`}
              alt="Arquivo"
              style={{ zIndex: 11 }}
            />
          ) : (
            <iframe
              title="Visualizador de PDF"
              src={`data:application/pdf;base64,${base64}`}
              width="100%"
              height="80%"
              style={{ border: "none" }}
            />
          )}
        </div>
      </Modal>
      <Modal
        showModal={showModalB}
        setShowModal={setShowModalB}
        title="Alerta"
        width="auto"
        button001_Nome={del?.excluir ? "Excluir" : "Cancelar"}
        button001_onClick={() => {
          handleDeletaEmpresa();
        }}
        showButton001
      >
        <div className="alerta">{UtilServices.stringToJsx(del?.mensagem)}</div>
      </Modal>
    </div>
  );
};

export default RPAs;
